import { useState } from "react";
import APIS from "../../constant/EndPoint";
import AutoFillComboboxInput from "../Reusable/AutoFillComboboxInput";
import ComboboxInput from "../Reusable/ComboboxInput";
import DateInput from "../Reusable/DateInput";
import LocalCombobox from "../Reusable/LocalCombobox";
import PaymentMethodCombobox from "../Reusable/PaymentMethodCombobox";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useWatch } from "react-hook-form";
import Modal from "../Reusable/Modal";
import InfoIcon from "../../Icons/InfoIcon";
import LocationCombobox from "../Reusable/Combobox";
import usePermission from "../../customHooks/usePermission";

const OrderForm = (props: any) => {
  const {
    errors,
    register,
    setValue,
    getValues,
    clearErrors,
    watch,
    vendorRef,
    setSenderId,
    setReceiverId,
    fields,
    remove,
    append,
    profile,
    control,
    setIsManualFreight,
  } = props;
  const [coveredArea, setCoveredArea] = useState("");
  const [infoOpen, setInfoOpen] = useState(false);
  const destination = useWatch({
    control: control,
    name: "destination",
  });
  const canEditUpdateConsignment = usePermission({
    allowedPermissions: ["can_create_consignment"],
  });

  const handleSubProduct = () => {
    append({
      package_type: null,
      calculated_by: null,
      piece: 1,
      weight: 0,
      rate: 0,
      remark: null,
    });
  };

  const index: number = fields?.length;
  const Unit = [
    {
      id: "weight",
      name: "weight",
    },
    {
      id: "piece",
      name: "piece",
    },
    {
      id: "volume",
      name: "volume",
    },
  ];

  return (
    <>
      <div className={tw`w-full grid grid-cols-3 gap-x-4 px-4`}>
        <>
          <ComboboxInput
            control={control}
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("vendor")}
            errors={errors?.vendor}
            name={"vendor"}
            label={"Vendor/Merchant"}
            props={{
              is_active: true,
            }}
            setValue={setValue}
            disabled={!canEditUpdateConsignment}
            placeholder={"Search Vendor/Merchant"}
            getValues={getValues}
            clearErrors={clearErrors}
            ref={vendorRef}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"barnch"}
            register={register("pickup_branch")}
            errors={errors?.pickup_branch}
            name={"pickup_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            placeholder={"Search Pickup Branch"}
            clearErrors={clearErrors}
            disabled={!profile?.is_superuser || !canEditUpdateConsignment}
          />
          <div className={tw`relative w-full flex flex-col`}>
            <LocationCombobox
              url={APIS.DESTINATION}
              props={{ level: 3, is_active: true }}
              queryKey={"location"}
              register={register(`destination`)}
              errors={errors?.destination}
              name={"destination"}
              label={"Destination"}
              setValue={setValue}
              getValues={getValues}
              disabled={!canEditUpdateConsignment}
              placeholder={"Search Destination City"}
              clearErrors={clearErrors}
              onSelect={(location: any) => {
                setCoveredArea(
                  location.covered_area ||
                    location.parent?.covered_area ||
                    "Not available"
                );
              }}
            />
            {destination && (
              <button
                type="button"
                onClick={() => setInfoOpen(true)}
                className={tw`absolute right-[3.5rem] top-[77%] -translate-y-1/2  rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 focus:outline-none`}
                title="Show Covered Area"
              >
                <InfoIcon />
              </button>
            )}
          </div>
          {/* <div className={tw`grid grid-cols-2 gap-x-2`}>
            <TextField
              register={register("hawb_no")}
              errors={errors?.hawb_no}
              disable={!canEditUpdateConsignment}
              label={"HAWB No.:"}
            />
            <ComboboxInput
              url={APIS.SHIP_VIA}
              queryKey={"ship-via"}
              register={register(`ship_via`)}
              errors={errors?.ship_via}
              name={`ship_via`}
              label={"Ship Via"}
              disabled={!canEditUpdateConsignment}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={"Search Ship Via"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div> */}

          <Modal isOpen={infoOpen} setIsOpen={setInfoOpen} title="Covered Area">
            <div className={tw`p-4 w-full mx-auto`}>
              <p className={tw`text-gray-800 mt-4 text-lg`}>{coveredArea}</p>
            </div>
          </Modal>
        </>
      </div>
      <div>
        <div
          className={tw`w-full mt-2 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
        >
          <div className={tw`text-[#5E5757] font-bold text-sm`}>
            Sender Informations
          </div>
        </div>
        <div className={tw`w-full grid grid-cols-4  px-4 gap-4`}>
          <AutoFillComboboxInput
            url={APIS.CUSTOMER}
            queryKey={"customer"}
            register={register("sender_full_name")}
            errors={errors?.sender_full_name}
            props={{
              is_active: true,
            }}
            name={`sender_full_name`}
            label={"Full Name"}
            setValue={setValue}
            disabled={!canEditUpdateConsignment}
            setSenderId={setSenderId}
            placeholder={"Search Sender"}
            getValues={getValues}
            watch={watch}
            clearErrors={clearErrors}
          />
          <TextField
            label={"Address"}
            register={register("sender_address")}
            errors={errors?.sender_address}
            disable={!canEditUpdateConsignment}
          />
          <PhoneNumberField
            control={control}
            label={"Phone Number"}
            name={"sender_phone_number"}
            errors={errors?.sender_phone_number}
            disabled={!canEditUpdateConsignment}
          />
          <TextField
            label={"VAT/PAN"}
            register={register("sender_vat_pan")}
            errors={errors?.sender_vat_pan}
            disable={!canEditUpdateConsignment}
          />
        </div>
      </div>
      <div>
        <div
          className={tw`w-full mt-2 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
        >
          <div className={tw`text-[#5E5757] font-bold text-sm`}>
            Receiver Informations
          </div>
        </div>
        <div className={tw`w-full grid grid-cols-4  px-4 gap-4`}>
          <AutoFillComboboxInput
            url={APIS.CUSTOMER}
            queryKey={"customer"}
            register={register("receiver_full_name")}
            errors={errors?.receiver_full_name}
            props={{
              is_active: true,
            }}
            name={`receiver_full_name`}
            label={"Full Name"}
            setValue={setValue}
            setSenderId={setReceiverId}
            placeholder={"Search Receiver"}
            getValues={getValues}
            watch={watch}
            clearErrors={clearErrors}
            disabled={!canEditUpdateConsignment}
          />
          <TextField
            label={"Address"}
            register={register("receiver_address")}
            errors={errors?.receiver_address}
            disable={!canEditUpdateConsignment}
          />
          <PhoneNumberField
            control={control}
            label={"Phone Number"}
            name={"receiver_phone_number"}
            errors={errors?.receiver_phone_number}
            disabled={!canEditUpdateConsignment}
          />
          <TextField
            label={"VAT/PAN"}
            register={register("receiver_vat_pan")}
            errors={errors?.receiver_vat_pan}
            disabled={!canEditUpdateConsignment}
          />
        </div>
      </div>
      <div
        className={tw`w-full mt-2 flex justify-between px-4 gap-x-2 uppercase  items-center`}
      >
        <div className={tw`text-[#5E5757] font-bold text-sm`}>
          Shipment Information
        </div>
      </div>
      <div className={tw`w-full grid grid-cols-3 gap-x-2 px-4`}>
        <ComboboxInput
          url={APIS.SERVICE_TYPE}
          queryKey={"service-type"}
          register={register(`service_type`)}
          errors={errors?.service_type}
          name={`service_type`}
          label={"Service Type"}
          props={{
            is_active: true,
          }}
          setValue={setValue}
          placeholder={"Search Service Type"}
          getValues={getValues}
          clearErrors={clearErrors}
          disabled={!canEditUpdateConsignment}
        />
        <PaymentMethodCombobox
          url={APIS.PAYMENT_METHOD_TYPE}
          queryKey={"payment-method"}
          register={register(`payment_method`)}
          errors={errors?.payment_method}
          name={`payment_method`}
          disabled={getValues("vendor") && !profile?.is_superuser}
          props={{
            is_active: true,
          }}
          label={"Payment Method"}
          setValue={setValue}
          placeholder={"Search Payment Method"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
      <hr className={tw`mt-2`} />
      <div id="sub-product">
        {fields.map((field: any, index: any) => {
          return (
            <div key={field?.id}>
              <div
                className={tw`relative w-full mt-1 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
              >
                <div className={tw`text-[#5E5757] font-bold text-xs`}>
                  Order {index + 1}
                </div>
                <button
                  type="button"
                  className={tw`rounded p-1  border border-gray-400 text-xs`}
                  disabled={index === 0 ? true : false}
                  onClick={() => remove(index)}
                >
                  Remove ({index + 1})
                </button>
              </div>
              <div className={tw`w-full grid grid-cols-6 gap-x-4 px-4`}>
                <TextField
                  label={"Product Description"}
                  register={register(`order_items.${index}.remark` as const)}
                  errors={errors.remark}
                  disable={!canEditUpdateConsignment}
                />
                <ProductTypeComboboxInput
                  url={APIS.PRODUCT_TYPE}
                  queryKey={"product-type"}
                  register={register(`order_items.${index}.package_type`)}
                  errors={errors?.order_items?.[index]?.package_type}
                  name={`order_items.${index}.package_type`}
                  props={{
                    is_active: true,
                  }}
                  label={"Product Type"}
                  setValue={setValue}
                  placeholder={"Search Product Type"}
                  index={index}
                  disabled={!canEditUpdateConsignment}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  value={getValues()["order_items"][index]["package_type"]}
                />
                <LocalCombobox
                  label={"Unit"}
                  errors={errors?.order_items?.[index]?.calculated_by}
                  setValue={setValue}
                  register={register(`order_items.${index}.calculated_by`)}
                  placeholder={"Search unit"}
                  name={`order_items.${index}.calculated_by`}
                  getValues={getValues}
                  disabled={!canEditUpdateConsignment}
                  clearErrors={clearErrors}
                  data={Unit}
                  value={getValues()["order_items"][index]["calculated_by"]}
                />
                <TextField
                  label={"Pcs."}
                  register={register(`order_items.${index}.piece`)}
                  disable={
                    !getValues()["order_items"][index]["calculated_by"] ||
                    !canEditUpdateConsignment
                  }
                  errors={errors?.order_items?.[index]?.piece}
                />
                <TextField
                  label={"Weight"}
                  register={register(`order_items.${index}.weight`)}
                  disable={
                    !getValues()["order_items"][index]["calculated_by"] ||
                    !canEditUpdateConsignment
                  }
                  errors={errors?.order_items?.[index]?.weight}
                />
                <TextField
                  label={"Rate"}
                  register={register(`order_items.${index}.rate`)}
                  disable={
                    !getValues()["order_items"][index]["calculated_by"] ||
                    !canEditUpdateConsignment
                  }
                  errors={errors?.order_items?.[index]?.rate}
                />
              </div>
            </div>
          );
        })}
        <div className={tw`w-full flex justify-end px-4`}>
          <button
            type="button"
            className={tw`rounded p-1 mb-1 border border-gray-400 text-xs`}
            disabled={
              !getValues()["order_items"]?.[index - 1]?.calculated_by ||
              !canEditUpdateConsignment
            }
            onClick={() => handleSubProduct()}
          >
            Add Product
          </button>
        </div>
        <hr />
      </div>
      <div className={tw`w-full grid grid-cols-4 gap-x-2 px-4`}>
        <ComboboxInput
          url={APIS.REFERENCE_TYPE}
          queryKey={"reference-type"}
          register={register(`reference_type`)}
          errors={errors?.reference_type}
          name={"reference_type"}
          label={"Document Type"}
          setValue={setValue}
          props={{
            is_active: true,
          }}
          getValues={getValues}
          disabled={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          placeholder={"Search Document Type"}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Doc. Number"}
          placeholder={"Doc. Number"}
          disable={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          register={register(`reference_number`)}
          errors={errors?.reference_number}
        />
        <DateInput
          type="date"
          label={"Document Date"}
          disabled={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          register={register(`reference_date`)}
          errors={errors?.reference_date}
        />
        <TextField
          type="text"
          label={"Goods Value"}
          disable={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          register={register(`order_value`)}
          errors={errors?.reference_date}
        />
      </div>
      <hr className={tw``} />
      <div className={tw`text-[#5E5757] font-semibold text-sm px-4 uppercase`}>
        Charges
      </div>
      <div className={tw`w-full grid grid-cols-4 gap-x-2 px-4`}>
        <div className={tw`flex gap-x-2 w-full`}>
          <TextField
            type="text"
            label={"Freight"}
            disable={
              !getValues()["order_items"]?.[index - 1]?.calculated_by ||
              !canEditUpdateConsignment
            }
            register={register(`delivery_charge`)}
            errors={errors?.delivery_charge}
            onBlur={() => setIsManualFreight(true)}
          />
        </div>
        <TextField
          label={"St. Charge "}
          disable={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          register={register(`extra_charges.st`)}
          errors={errors?.extra_charges?.st}
        />
        <TextField
          label={"Total"}
          register={register(`total_charge`)}
          disable={true}
          errors={errors?.total_charge}
        />
      </div>
      <hr />
      <div className={tw`grid grid-cols-3 gap-x-4 px-4`}>
        <TextField
          type="text"
          disable={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          label={"COD Amount"}
          register={register(`cod`)}
          errors={errors?.cod}
        />
        <TextField
          label={"Remarks"}
          disable={
            !getValues()["order_items"]?.[index - 1]?.calculated_by ||
            !canEditUpdateConsignment
          }
          register={register(`note`)}
          errors={errors?.note}
        />
      </div>
    </>
  );
};

export default OrderForm;
